import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const STORAGE_KEY = 'dermalipo_cookie_consent_v1';
export function CookieBanner() {
  const {
    lang
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Slight delay to not jump the user immediately
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setIsVisible(false);
  };
  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setIsVisible(false);
  };
  const copy = lang === 'es' ? {
    title: 'Cookies y privacidad',
    body: 'Usamos cookies para mejorar tu experiencia, medir el rendimiento del sitio y personalizar publicidad en Meta. Tu privacidad es importante para nosotros.',
    accept: 'Aceptar',
    reject: 'Rechazar',
    learnMore: 'Más información'
  } : {
    title: 'Cookies & privacy',
    body: 'We use cookies to enhance your experience, measure site performance, and personalize Meta advertising. Your privacy matters to us.',
    accept: 'Accept',
    reject: 'Reject',
    learnMore: 'Learn more'
  };
  return <AnimatePresence data-id="element-297">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: [0.33, 1, 0.68, 1]
    }} className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-auto md:right-6 md:max-w-md z-[60]" data-id="element-298">
          <div className="relative bg-brand-cream border border-brand-stone/60 rounded-2xl shadow-xl p-6 pr-10" data-id="element-299">
            <button onClick={handleReject} aria-label="Close" className="absolute top-4 right-4 text-brand-dark/40 hover:text-brand-dark transition-colors" data-id="element-300">
              <XIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-301" />
            </button>

            <div className="flex items-center gap-3 mb-3" data-id="element-302">
              <span className="w-6 h-px bg-brand-gold" data-id="element-303"></span>
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/60" data-id="element-304">
                {copy.title}
              </p>
            </div>

            <p className="text-sm text-brand-dark/70 font-light leading-relaxed mb-5" data-id="element-305">
              {copy.body}{' '}
              <Link to="/privacy" className="underline underline-offset-2 hover:text-brand-dark" data-id="element-306">
                {copy.learnMore}
              </Link>
            </p>

            <div className="flex items-center gap-3" data-id="element-307">
              <button onClick={handleAccept} className="flex-1 bg-brand-dark text-brand-cream text-[11px] font-semibold tracking-[0.15em] uppercase py-3 rounded-full hover:bg-brand-ink transition-colors" data-id="element-308">
                {copy.accept}
              </button>
              <button onClick={handleReject} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors px-4 py-3" data-id="element-309">
                {copy.reject}
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}